<div
  class="flex w-full items-center"
>
  <img
    alt="Solvace"
    class="w-auto max-w-fit max-h-8"
    [src]="environment.logoImageNegative"
  />

  <div class="flex-auto flex justify-center uppercase text-base font-semibold">
    <ng-content />
  </div>

  <!-- TODO: Remover botao do svc-dialog-primary -->
<!--  <button-->
<!--    class="close-button -mr-1 print:hidden"-->
<!--    mat-icon-button-->
<!--    (click)="closeDialog()"-->
<!--  >-->
<!--    <mat-icon class="text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>-->
<!--  </button>-->
</div>
